export const QUERY_TAXES_TAX_ESTIMATE = "QUERY_TAXES_TAX_ESTIMATE";
export const QUERY_TAXES_WITHHOLDING_BALANCE =
  "QUERY_TAXES_WITHHOLDING_BALANCE";
export const QUERY_TAXES_WITHHOLDING_TRANSACTIONS =
  "QUERY_TAXES_WITHHOLDING_TRANSACTIONS";
export const QUERY_TAXES_PENDING_WITHHOLDING_LIST =
  "QUERY_TAXES_PENDING_WITHHOLDING_LIST";
export const QUERY_TAXES_PENDING_WITHHOLDING =
  "QUERY_TAXES_PENDING_WITHHOLDING";
